/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CreateJiraIssueWrapper = styled.form({
  display: 'flex',
  flexDirection: 'column',
  marginTop: token('space.100'),
  maxWidth: `${gridSize() * 110}px`,
});

export const CreateJiraIssueActionsContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  color: token('color.text.subtlest'),
});

export const CreateJiraIssueActionsInnerContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  /* Need to set an explicit white background here so that SpotlightTarget
  component uses the correct background color when onboarding is shown. */
  backgroundColor: token('color.background.input'),
});

export const CancelButton = styled(Button)({
  paddingRight: 0,
});

export const SubmitButton = styled(Button)({
  paddingRight: 0,
});

export const CreateIssueSpinnerWrapper = styled.div({
  marginRight: token('space.050'),
});
